import { createSlice } from "@reduxjs/toolkit";
import vars from "utils/vars";

const initialState = {
	uiUserPasswordUpdateNeeded: JSON.parse(
		localStorage.getItem(vars.localStorage.fieldsName.uiUserPasswordUpdateNeeded) || "false"
	),
	uiNotesScheduleView: localStorage.getItem(vars.localStorage.fieldsName.uiNotesScheduleView) || "timeGridDay",
	uiIsDashboardSideCollapsed: JSON.parse(
		localStorage.getItem(vars.localStorage.fieldsName.uiIsDashboardSideCollapsed) || "false"
	),
	isNoteCasesOffcanvasOpen: false,
	isNoteOwnerTenantOffcanvasOpen: false,
	isReferralCasesOffcanvasOpen: false,
	isNoteOutputOffcanvasOpen: false,
	isNoteLoading: false,
	isQuestionsLoading: false,
	isBasicQuestionsLoading: false,
	isNoteStatementsLoading: false,
	isNoteProceduresLoading: false,
	isNoteOrdersLoading: false,
	isQuestionsShown: false,
	isPatientHistoryShown: false,
	isSegmentsLoading: false,
	isNotePatientLoading: false,
	processingOrderDocument: "",
};

export const slice = createSlice({
	name: "ui",
	initialState,
	reducers: {
		resetAll: ({ processingOrderDocument, ...state }) => ({
			...(state || {}),
			...initialState,
			processingOrderDocument,
		}),
		changeUserPasswordUpdateNeeded: (state, { payload }) => {
			localStorage.setItem(vars.localStorage.fieldsName.uiUserPasswordUpdateNeeded, payload);
			return { ...(state || {}), uiUserPasswordUpdateNeeded: payload };
		},
		changeIsDashboardSideCollapsed: (state, { payload }) => {
			localStorage.setItem(vars.localStorage.fieldsName.uiIsDashboardSideCollapsed, payload);
			return { ...(state || {}), uiIsDashboardSideCollapsed: payload };
		},
		changeNotesScheduleView: (state, { payload }) => {
			localStorage.setItem(vars.localStorage.fieldsName.uiNotesScheduleView, payload);
			return { ...(state || {}), uiNotesScheduleView: payload };
		},
		toggleNoteCasesOffcanvas: (state) => ({
			...(state || {}),
			isNoteCasesOffcanvasOpen: !state?.isNoteCasesOffcanvasOpen,
		}),
		toggleNoteOwnerTenantOffcanvas: (state) => ({
			...(state || {}),
			isNoteOwnerTenantOffcanvasOpen: !state?.isNoteOwnerTenantOffcanvasOpen,
		}),
		closeNoteCasesOffcanvas: (state) => ({ ...(state || {}), isNoteCasesOffcanvasOpen: false }),
		openNoteCasesOffcanvas: (state) => ({ ...(state || {}), isNoteCasesOffcanvasOpen: true }),
		closeNoteOwnerTenantOffcanvas: (state) => ({ ...(state || {}), isNoteOwnerTenantOffcanvasOpen: false }),
		openNoteOwnerTenantOffcanvas: (state) => ({ ...(state || {}), isNoteOwnerTenantOffcanvasOpen: true }),
		closeReferralCasesOffcanvas: (state) => ({ ...(state || {}), isReferralCasesOffcanvasOpen: false }),
		openReferralCasesOffcanvas: (state) => ({ ...(state || {}), isReferralCasesOffcanvasOpen: true }),
		toggleNoteOutputOffcanvas: (state) => ({
			...(state || {}),
			isNoteOutputOffcanvasOpen: !state?.isNoteOutputOffcanvasOpen,
		}),
		closeNoteOutputOffcanvas: (state) => ({ ...(state || {}), isNoteOutputOffcanvasOpen: false }),
		openNoteOutputOffcanvas: (state) => ({ ...(state || {}), isNoteOutputOffcanvasOpen: true }),
		setIsNoteLoading: (state, { payload }) => ({ ...(state || {}), isNoteLoading: payload }),
		setIsQuestionsLoading: (state, { payload }) => ({ ...(state || {}), isQuestionsLoading: payload }),
		setIsBasicQuestionsLoading: (state, { payload }) => ({ ...(state || {}), isBasicQuestionsLoading: payload }),
		setIsNoteStatementsLoading: (state, { payload }) => ({ ...(state || {}), isNoteStatementsLoading: payload }),
		setIsNoteProceduresLoading: (state, { payload }) => ({ ...(state || {}), isNoteProceduresLoading: payload }),
		setIsNoteOrdersLoading: (state, { payload }) => ({ ...(state || {}), isNoteOrdersLoading: payload }),
		setIsQuestionsShown: (state, { payload }) => ({ ...(state || {}), isQuestionsShown: payload }),
		setIsPatientHistoryShown: (state, { payload }) => ({ ...(state || {}), isPatientHistoryShown: payload }),
		setIsSegmentLoading: (state, { payload }) => ({ ...(state || {}), isSegmentsLoading: payload }),
		setIsNotePatientLoadingLoading: (state, { payload }) => ({ ...(state || {}), isNotePatientLoading: payload }),
		setProcessingOrderDocument: (state, { payload }) => ({ ...(state || {}), processingOrderDocument: payload }),
	},
});

export const uiSelector = (state) => state?.ui || {};

export const { actions, reducer } = slice;

export default reducer;
